import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DotsThreeVertical, ArrowsClockwise, Clock, Receipt, ChatCircleText, CurrencyDollar, Sparkle, PencilSimple, Trash } from "@phosphor-icons/react";

// Menú de acciones de un producto (mismo set que la columna "Acciones", pero a la mano).
export default function ProductActionsMenu({ product: p, perms, on, trigger, align = "start", testid }) {
  const { canEdit, canSuggest, canUseAlendra, canMakeMovement } = perms;
  const Item = ({ icon: Icon, label, onClick, cls = "", id }) => (
    <DropdownMenuItem onClick={onClick} className={`gap-2 cursor-pointer ${cls}`} data-testid={`${testid}-${id}`}>
      <Icon size={15} weight="bold" /> {label}
    </DropdownMenuItem>
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {trigger || (
          <button type="button" className="p-1 rounded hover:bg-zinc-200 text-zinc-500 hover:text-zinc-900" title="Acciones del producto" data-testid={testid}>
            <DotsThreeVertical size={18} weight="bold" />
          </button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-60" data-testid={`${testid}-content`}>
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-zinc-500 truncate">{p.name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {canMakeMovement && <Item id="mov" icon={ArrowsClockwise} label="Movimiento de stock" onClick={() => on.movement(p)} />}
        {canEdit && <Item id="edit" icon={PencilSimple} label="Editar producto" onClick={() => on.edit(p)} />}
        <Item id="sales" icon={Receipt} label="Ventas de este producto" onClick={() => on.sales(p)} />
        {canEdit && <Item id="history" icon={Clock} label="Historial completo" cls="text-violet-700" onClick={() => on.history(p)} />}
        {canSuggest && <Item id="suggest" icon={ChatCircleText} label="Sugerir cambio de fotos" cls="text-amber-700" onClick={() => on.suggest(p)} />}
        {canUseAlendra && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-zinc-500">Alendra AI</DropdownMenuLabel>
            <Item id="pricing" icon={CurrencyDollar} label="Analizar precio" cls="text-emerald-700" onClick={() => on.pricing(p)} />
            <Item id="seo" icon={Sparkle} label="Generar SEO" cls="text-[#002FA7]" onClick={() => on.seo(p)} />
          </>
        )}
        {canEdit && (
          <>
            <DropdownMenuSeparator />
            <Item id="delete" icon={Trash} label="Eliminar producto" cls="text-[#E0000F] focus:text-[#E0000F]" onClick={() => on.delete(p)} />
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
